import { CustomerTag, CustomerTags, GetCustomersV2Response, GetCustomersV2Request } from './../../../common/models/customer';
import { destroy, get, patch, post, put } from 'api';
import axios, { AxiosResponse, CancelToken, CancelTokenSource } from 'axios';
import Customer, { CustomerDto, OwnedUnitDto } from 'common/models/customer';
import { RouteConstants } from 'common/utils/shared/routes-constants';
import { CustomerContactNew } from 'components/customer/components/CustomerDrawer/CustomerContactDrawer';
import config from 'config';
import { v1 as uuidv1 } from 'uuid';
import { BaseResponse } from 'common/utils/shared/shared-models';
import { CustomerTagRequest } from 'components/setting/models/customer-tag-title';
import { isString } from 'lodash';

const BASE_URL = config.get('api.customer');
const BASE_URL_Messages = config.get('api.messaging');

const GoogleApiKey = config.get('api.googlePlaces');

interface GetCustomersResponse {
  customers: CustomerDto[];
  count: number;
  pageSize: number;
  pageNumber: number;
}
export interface CustomerCategory {
  customerCategoryId: string;
  dealerId: number;
  isActive: boolean;
  lastUpdated: Date;
  name: string;
}

export interface CustomerPhoneType {
  dealerId: number;
  customerPhoneTypeId: number;
  name: string;
  lastUpdated: Date;
}
export interface CustomerEmailType {
  dealerId: number;
  customerEmailTypeId: number;
  name: string;
  lastUpdated: Date;
}
export interface GravityPaymentsInvoiceRequest {
  query?: "GetOrders";
  queryBody: QueryBody;
}
export interface QueryBody {
  DealerId: number;
  PageNumber?: number;
  PageSize?: number;
  CustomerId: string;
  OrderStatus?: string;
  OrderType?: string;
  WithDetails?: number;
}
export type GravityPaymentInvoicesResponse = GravityPaymentInvoicesData[];
export interface GravityPaymentInvoicesData {
  dealerId?: number
  orderStatus?: string
  orderTypeId?: number
  orderStatusId?: number
  invoiceId?: number
  orderId?: number
  invoiceNumber?: number
  invoiceDate?: string
  customerId?: number
  isInternal?: boolean
  hasPartsInvoice?: boolean
  hasWorkOrder?: boolean
  hasSalesDeal?: boolean
  hasRental?: boolean
  isWarranty?: boolean
  isQuote?: boolean
  isActive?: boolean
  tax?: number
  invoiceAmount?: number
  customer?: string
  dmsOrderStatus?: any
  payment?: number
}

export interface TextToPayLinkRequest {
  dealerId: number;
  crmCustomerId: number;
  customerName: string;
  departmentName: string;
  memo: string;
  amount: string;
  invoiceId: string;
  orderId?: number; // Optional property
}
export interface GetCustomerContactsRequest {
  dealerId: number;
  crmCustomerId: number;
}
export interface MergeSocialCustomerRequest {
  dealerId: number;
  socialCrmCustomerId: number;
  targetCrmCustomerId: number;
}
export interface TextToPayLinkResponse {
  paymentPageId: string;
  paymentPageUrl: string;
  externalTransId: string;
  linkExpiryDate?: Date;
  urlShortener: string;
}

/**
 * New OwnedUnits Interfaces
 */
export interface OwnedUnitsRequest {
  pageNumber?: number;
  pageSize?: number;
  searchStatus?: string;
  customerId: number;
  manufacturerId?:string | number; // optional ManufacturerId (Line)
  dmsLocationId?: string | number;
  xSearchType?: string; // optional xSearchType (e.g. "SerialNumber")
  xSearch?: string; // optional xSearch (e.g. serial value)
  unitStatus?: number;
  condition?: number;
}

export interface GetOwnedUnitsResponse {
  totalCount: number;
  pageNumber: number;
  units: OwnedUnitDto[];
}
// manufecturer Lookups
export interface ResponseManufacturersLookUp {
  manufacturerId: string;
  code: string;
  commonCode: string;
  commonMfgId: number;
  name: string;
  isPartManufacturer: boolean;
  isWholegoodManufacturer: boolean;
  moreInfo?: string | null;
  isActive: boolean;
  dealerId: number;
  lastUpdated?: string | null;
}

// DealerLocationlookup

export interface DealerLocation {
  dealerId: number;
  dmsType: string;
  dmsDealerId: number;
  dmsLocationId: number;
  companyDealerId: number;
  name: string;
  address: string;
  city: string;
  stateOrProvince: string;
  zipPostal: string;
  countryCode: string;
  timezone: number;
  isTest: boolean;
  isDealerLocation: boolean;
  phone: string;
  email: string;
  rootDealerId?: number | null;
  dealerNumber?: string | null;
  dealerGuid: string;
}

let token: CancelTokenSource;
let ownedUnitToken: CancelTokenSource; 
let manufacturerLookupToken: CancelTokenSource ;

const getCustomersV2 = async (
  params: GetCustomersV2Request = {
    pageNumber: 0,
    pageSize: 10,
    searchString: '',
  }
): Promise<GetCustomersV2Response> => {
  try {
    if (token) {
      token.cancel();
    }
    const searchValue = encodeURIComponent(params.searchString);
    token = axios.CancelToken.source();
    const { data } = await get<GetCustomersV2Response>(
      `${BASE_URL}/v2/getCustomersV2?pageNumber=${params.pageNumber}&pageSize=${params.pageSize}&searchValue=${searchValue}`,
      { cancelToken: token.token }
    );
    return data;
  } catch (error: any) {
    if (axios.isCancel(error)) {
      console.warn('Request canceled:', error.message ?? 'Request canceled by the user');
    } else {
      console.error('Error fetching customers:', error);
    }
    return { customers: [], totalRecords: 0, pageNumber: 0, pageSize: 0 };
  }
};

const getCustomers = async (
  dealerId: number,
  page: number,
  pageSize: number,
  searchString: string,
  excludeFlagged = false,
  excludeFacebookCustomer = false,
  excludeInstagramCustomers = false
): Promise<any> => {
  if (token) {
    token.cancel();
  }
  let searchstr = searchString.replace('&', '%26');
  token = axios.CancelToken.source();
  const axiosResponse = await get<GetCustomersResponse>(
    `${BASE_URL}/v2/customers?dealerId=${dealerId}&pageNumber=${page}&pageSize=${pageSize}&searchString=${searchstr}&excludeFlagged=${excludeFlagged}&excludeFacebookCustomer=${excludeFacebookCustomer}&excludeInstagramCustomers=${excludeInstagramCustomers}`,
    { cancelToken: token.token },
  );
  return axiosResponse?.data;
};

const searchCustomersAndContacts = async (dealerId: number, page: number, pageSize: number, searchString: string, crmCustomerId: number): Promise<any> => {
  if (token) {
    token.cancel();
  }
  let searchstr = searchString.replace('&', '%26');
  token = axios.CancelToken.source();
  const cancelTokenOption = crmCustomerId === 0 ? { cancelToken: token.token } : {};
  const axiosResponse = await get<any>(
    `${BASE_URL}/v2/searchCustomersAndContacts?dealerId=${dealerId}&pageNumber=${page}&pageSize=${pageSize}&crmCustomerId=${crmCustomerId}&searchString=${searchstr}`,
    cancelTokenOption
  );
  return axiosResponse?.data;
};

const addCustomer = async (dealerId: number, customer: Customer): Promise<number> => {
  customer.dealerId = dealerId;
  return await post(`${BASE_URL}/customer/details`, customer, { headers: { Guid: uuidv1() } });
};

const getCustomer = async (crmCustomerId: number): Promise<any> => {
  const { data } = await get(`${BASE_URL}/customer/detailsv2/${crmCustomerId}`);
  return data;
};

const getCustomerCrmIdByCustomerId = async (customerId: number, dealerId: number = 0): Promise<any> => {
  const { data } = await get(`${BASE_URL}/customerCrmIdByCustomerId/${customerId}/${dealerId}`);
  return data;
};

const editCustomer = async (dealerId: number, customer: Customer): Promise<any> => {
  try {
    return await put(`${BASE_URL}/customer/detailsv2/${customer.crmCustomerId}`, customer);
  } catch (error) {
    console.error(error);
    return null;
  }
};

const deleteCustomer = async (dealerId: number, customerId: number): Promise<any> => {
  try {
    return await destroy(`${BASE_URL}/customers/${customerId}`);
  } catch (error) {
    return null;
  }
};

const getPhoneTypes = async (dealerId: number): Promise<CustomerPhoneType[]> => {
  try {
    let resp = await get(`${BASE_URL}/customer/details/phone/types/`);
    return resp.data;
  } catch (err) {
    return [];
  }
};

const getEmailTypes = async (dealerId: number): Promise<CustomerEmailType[]> => {
  try {
    let resp = await get(`${BASE_URL}/customer/details/email/types/`);
    return resp.data;
  } catch (err) {
    return [];
  }
};

const getCategories = async (dealerId: number): Promise<CustomerCategory[]> => {
  try {
    let resp = await get(`${BASE_URL}/customer/details/categories/`);
    return resp.data;
  } catch (err) {
    return [];
  }
};
const getCustomerPhoneNumberCount = async (crmCustomerIds: number[] | null): Promise<any> => {
  try {
    return await post(`${BASE_URL}/getCustomerPhoneNumbersCount/`, crmCustomerIds);
  } catch (err) {
    return null;
  }
};

const toggleCustomerOptIn = async (crmCustomerId: number, optInStatus: number): Promise<any> => {
  try {
    return await patch(`${BASE_URL}/customer/details/optin/`, { crmCustomerId, optIn: optInStatus });
  } catch (err) {
    return null;
  }
};
const getPhoneNumbers = async (crmCustomerId: number): Promise<any> => {
  try {
    let response = await get(`${BASE_URL}/customer/details/phonenumbers/${crmCustomerId}`);
    return response.data;
  } catch (err) {
    return null;
  }
};

const updatePhoneNumberToPrimary = async (crmCustomerId: number, phoneNumberId: number): Promise<any> => {
  try {
    return await patch(`${BASE_URL}/customer/details/phonenumbers/primary/${crmCustomerId}/${phoneNumberId}`, {
      phoneNumberId,
    });
  } catch (err) {
    return null;
  }
};

const GetContacts = async (json: string): Promise<any> => {
  try {
    let resp = await get(`${BASE_URL}/ExecuteJsonSP/Customers.spGetContacts/${json}`);
    return resp.data;
  } catch (err) {
    return null;
  }
};

const GetContactsV2 = async (contactReq: GetCustomerContactsRequest, cancelToken?: CancelToken): Promise<any> => {
  try {
    let resp = await post(`${BASE_URL}/customer/GetCustomerContacts`, contactReq, { cancelToken });
    return resp.data;
  } catch (err) {
    return null;
  }
};

const MergeSocialCustomer = async (fbReq: MergeSocialCustomerRequest): Promise<any> => {
  try {
    let resp = await post(`${BASE_URL}/customer/MergeSocialCustomer`, fbReq);
    return resp;
  } catch (err) {
    return null;
  }
};

const GetJsonSp = async (sp: string, json: string): Promise<string> => {
  try {
    let resp = await get(`${BASE_URL}/ExecuteJsonSP/${sp}/${json}`);
    return resp.data;
  } catch (err) {
    return '';
  }
};

const addCustomerContact = async (dealerId: number, customerContact: CustomerContactNew): Promise<any> => {
  return await post(`${BASE_URL}/customer/contact/${dealerId}`, customerContact);
};

const checkCustomerNumberExists = async (req: any): Promise<any> => {
  try {
    let resp = await get(`${BASE_URL}/customer/customerNumberExists/${req.crmCustomerId}/${req.customerNumber}`);
    return resp.data;
  } catch (err) {
    return [];
  }
};

const validatePhoneNumber = async (phoneNumber: string): Promise<{ status: number, message: string }> => {
  const url = `${BASE_URL_Messages}/ValidateCellphone/${phoneNumber}`;
  let response: AxiosResponse<any>;
  try {
    response = await post(url);
    return { status: response.status, message: response.data };
  } catch (error: any) {
    if (error === "" || error === undefined) {
      return { status: 500, message: "Unkonwn error" };
    }
    return { status: 400, message: error };
  }
};

const fetchTextToPayLink = async (
  request: TextToPayLinkRequest
): Promise<BaseResponse<TextToPayLinkResponse>> => {
  try {
    const url = `${BASE_URL}/TextToPayCustomer`;
    const resp = await post(url, request);

    if (resp?.data) {
      return {
        data: resp.data as TextToPayLinkResponse,
        isSuccess: true,
        message: 'Request successful',
        error: ''
      };
    } else {
      return {
        data: null as any,
        isSuccess: false,
        message: 'No data returned',
        error: 'No data in the response'
      };
    }
  } catch (error: unknown) {
    const errorMessage = error instanceof Error ? error.message : (isString(error) ? error : 'Unknown error');
    return {
      data: null as any,
      isSuccess: false,
      message: 'Request failed',
      error: errorMessage
    };
  }
};

const GetCustomerTags = async (): Promise<CustomerTags[]> => {
  try {
    let url = `${BASE_URL}/customer/tags`;
    return await (await post(url)).data;
  } catch (err: any) {
    return err;
  }
}

const GetZipcode = async (lat: number, lng: number) => {
  try {
    const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${GoogleApiKey}`;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
};

const GetCustomerInvoices = async (request: GravityPaymentsInvoiceRequest): Promise<GravityPaymentInvoicesResponse> => {
  try {
    const url = `${BASE_URL}/fetchCustomerInvoices`;
    const resp = await post(url, request);
    return resp.data;
  } catch (err) {
    throw err;
  }
};

const getOwnedUnits = async (request: OwnedUnitsRequest): Promise<GetOwnedUnitsResponse> => {
  if (ownedUnitToken) {
    ownedUnitToken.cancel();
  }
  ownedUnitToken = axios.CancelToken.source();

  // prepare optional query parts
  const manufacturerQuery = request.manufacturerId 
    ? `&ManufacturerId=${encodeURIComponent(request.manufacturerId)}`
    : '';

  const unitStatusQuery = request.unitStatus && request.unitStatus != null
    ? `&UnitStatus=${encodeURIComponent(request.unitStatus)}`
    : '';

     const conditionQuery =request.condition !== undefined && request.condition !== null &&request.condition !== -1
    ? `&Condition=${request.condition}`
    : '';
     const dealerlocationQuery = request.dmsLocationId !== undefined && request.dmsLocationId !== null &&request.dmsLocationId !== -1 ? `&dmsLocationId=${request.dmsLocationId}` : '';
  // default xSearchType to 'SerialNumber' per sample; xSearch can be empty
  const xSearchTypeQuery = `&xSearchType=${encodeURIComponent(request.xSearchType ?? 'SerialNumber')}`;
  const xSearchQuery = `&xSearch=${encodeURIComponent(request.xSearch ?? '')}`;

  const url = `${BASE_URL}/FetchOwnedCustomer?pageNumber=${request.pageNumber ?? 1}` +
    `&pageSize=${request.pageSize ?? 15}` +
    `&searchStatus=${encodeURIComponent(request.searchStatus ?? 'All')}` +
    `&customerId=${request.customerId}` +
    `${xSearchTypeQuery}${xSearchQuery}${manufacturerQuery}${unitStatusQuery}${conditionQuery}${dealerlocationQuery}`;

  try {
    const axiosResponse = await get<GetOwnedUnitsResponse>(url, {
      cancelToken: ownedUnitToken.token,
    });
    return axiosResponse?.data;
  } catch (error: any) {
    if (axios.isCancel(error)) {
      console.warn('OwnedUnits request canceled:', error.message ?? 'Request canceled by the user');
    } else {
      console.error('Error fetching OwnedUnits:', error);
    }
    return { totalCount: 0, pageNumber: 0, units: [] };
  }
};


// manufecturer lookups
const getManufacturerLineLookup = async (): Promise<ResponseManufacturersLookUp[]> => {
  if (manufacturerLookupToken) {
    manufacturerLookupToken.cancel();
  }
  manufacturerLookupToken = axios.CancelToken.source();


  const url = `${BASE_URL}/FetchManufacturerLineLookup`;

  try {
    const axiosResponse = await get<ResponseManufacturersLookUp[]>(url, {
            cancelToken: manufacturerLookupToken.token,
    });

    return axiosResponse?.data ?? [];
  } catch (error: any) {
    if (axios.isCancel(error)) {
      console.warn('FetchManufacturerLineLookup request canceled:', error.message ?? 'Request canceled');
    } else {
      console.error('Error fetching ManufacturerLineLookup:', error);
    }

    return [];
  }
};



let dealerLocationLookupToken: CancelTokenSource | null = null;

const getDealerLocationLookup = async (): Promise<DealerLocation[]> => {
  if (dealerLocationLookupToken) {
    dealerLocationLookupToken.cancel();
  }

  dealerLocationLookupToken = axios.CancelToken.source();

  const url = `${BASE_URL}/FetchDealerLocationLookup`;

  try {
    const axiosResponse = await get<DealerLocation[]>(url, {
      cancelToken: dealerLocationLookupToken.token,
    });

    return axiosResponse?.data ?? [];
  } catch (error: any) {
    if (axios.isCancel(error)) {
      console.warn(
        'FetchDealerLocationLookup request canceled:',
        error.message ?? 'Request canceled'
      );
    } else {
      console.error('Error fetching DealerLocationLookup:', error);
    }

    return [];
  }
};


const getCustomerSummaryJson = async (jsonReq: string): Promise<string> => {
  try {
    const resp = await get(`${BASE_URL}/customer/summary/${jsonReq}`);
    return resp.data;
  } catch (err) {
    return '';
  }
};

// #region Part Number/Model Number Methods

let modelSuggestionToken: CancelTokenSource;

const cancelPartNumberToken = () => {
  if (modelSuggestionToken) {
    modelSuggestionToken.cancel();
  }
}
const getModelNumbers = async (searchKeyword: string, pageNumber: number, pageSize: number): Promise<any> => {
  cancelPartNumberToken();

  let url = `${RouteConstants.GetCustomerPartAndModelNumber}?`;
  if (pageNumber !== undefined) {
    url += `pageNumber=${pageNumber}`;
  }
  if (pageSize !== undefined) {
    url += `&pageSize=${pageSize}`;
  }
  if (searchKeyword !== undefined && searchKeyword != "") {
    url += `&searchKeyword=${searchKeyword}`;
  }

  modelSuggestionToken = axios.CancelToken.source();
  const { data } = await get(url, { cancelToken: modelSuggestionToken.token });

  return data;
};

/**
 * New OwnedUnits API
 */

export default {
  cancelPartNumberToken,
  getModelNumbers,
  getCustomers,
  getCustomer,
  searchCustomersAndContacts,
  addCustomer,
  editCustomer,
  deleteCustomer,
  toggleCustomerOptIn,
  updatePhoneNumberToPrimary,
  getCustomerPhoneNumberCount,
  getPhoneTypes,
  getPhoneNumbers,
  getEmailTypes,
  getCategories,
  GetContacts,
  GetContactsV2,
  MergeSocialCustomer,
  GetJsonSp,
  addCustomerContact,
  checkCustomerNumberExists,
  fetchTextToPayLink,
  GetCustomerTags,
  getCustomerCrmIdByCustomerId,
  GetZipcode,
  GetCustomerInvoices,
  validatePhoneNumber,
  getCustomerSummaryJson,
  getCustomersV2,
  getOwnedUnits,
  getManufacturerLineLookup,
  getDealerLocationLookup,
};
